import type { JSX } from "react";
import { useSearchParams } from "react-router";
import { TaskDocumentIdentifier } from "../../services/task-documents.ts";
import { TaskDocumentList } from "./TaskDocumentList.tsx";
import { TaskViewer } from "./TaskViewer.tsx";

export function TaskDocumentsPage(): JSX.Element {
  const [searchParams, setSearchParams] = useSearchParams();
  const selectedTask = TaskDocumentIdentifier.safeDecode(searchParams.get("taskId") ?? "");
  const selectedTaskId = selectedTask.success ? selectedTask.data : undefined;

  return (
    <section>
      <h1>Task Documents</h1>
      <div
        style={{
          display: "grid",
          gap: "var(--size-large)",
          gridTemplateColumns: "minmax(16rem, 22rem) minmax(0, 1fr)",
        }}
      >
        <TaskDocumentList
          onSelectTask={(taskId) =>
            setSearchParams((current) => {
              const next = new URLSearchParams(current);
              if (selectedTaskId === taskId) next.delete("taskId");
              else next.set("taskId", taskId);
              return next;
            })
          }
          selectedTaskId={selectedTaskId}
        />
        {selectedTaskId ? (
          <TaskViewer taskId={selectedTaskId} />
        ) : (
          <p>Select a task document to read it.</p>
        )}
      </div>
    </section>
  );
}
